export const ADD_PRISMIC_REF = "nested/App/ADD_PRISMIC_REF";
export const FETCH_PROPERTIES = "app/OurHomes/FETCH_PROPERTIES";
export const FETCH_PROPERTIES_SUCCESS = "app/OurHomes/FETCH_PROPERTIES_SUCCESS";
export const FETCH_PROPERTIES_ERROR = "app/OurHomes/FETCH_PROPERTIES_ERROR";
